import type { LocationQuery } from 'vue-router'

export const jobFilterSaveTargetKeys = [
  'status',
  'sort',
  'keyword',
  'occupations',
  'employments',
  'features',
  'raEmployeeCode',
  'csEmployeeCode',
  'agent',
]

export const useJobLastFilterCondition = () => {
  const lastJobFilterConditionOnStorage = useLocalStorage<
    Record<string, string>
  >(LAST_JOB_V2_FILTER_CONDITION, {})

  const saveLastJobFilterCondition = (query: LocationQuery) => {
    const filteredQuery = jobFilterSaveTargetKeys.reduce(
      (acc, key) => {
        const value = queryValueToString(query[key])
        if (value !== undefined) {
          acc[key] = value
        }
        return acc
      },
      {} as Record<string, string>,
    )
    lastJobFilterConditionOnStorage.value = filteredQuery
  }

  const getLastJobFilterCondition = () => {
    return Object.fromEntries(
      Object.entries(lastJobFilterConditionOnStorage.value).filter(([key]) =>
        jobFilterSaveTargetKeys.includes(key),
      ),
    )
  }

  return {
    saveLastJobFilterCondition,
    getLastJobFilterCondition,
  }
}
